module.exports = __webpack_public_path__ + "static/media/storms.a69b59b9.png";